module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "cooperativePartner",
    attrs: {
      "id": "cooperativePartner"
    }
  }, [_c('div', {
    staticClass: "coo_top"
  }, [_c('h1', {
    staticClass: "coo_title"
  }, [_vm._v("位置服务平台")]), _vm._v(" "), _c('p', {
    staticClass: "coo_name"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/index/coo_logo.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "coo_text"
  }, [_vm._v("通过“CRM+LBS+企业定制”的服务模式，为企业用户提供集地图服务和商业分析一体化的车联网位置服务平台及成熟的行业解决方案，在车辆实时监控、真实轨迹还原、轨迹BI分析、大数据可视化等方面，为用户提供稳定又精准的产品与服务。")]), _vm._v(" "), _c('ul', {
    staticClass: "coo_content"
  }, [_c('li', [_c('p', {
    staticClass: "p_fri"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/index/coo_1.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p_sec"
  }, [_vm._v("物联网综合管理平台")]), _vm._v(" "), _c('p', {
    staticClass: "p_thir"
  }, [_vm._v("基于中国移动运营商，为全国范围的物联网用户提供采用物联网专用号段的物联网卡的查询、短信批量发送、短信记录查询、流量查询、批量续费等相关业务功能的服务。该平台由用户管理、库存管理、SIM卡管理、账户管理等四个模块构成，满足用户不同管理需求。")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "p_fri"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/index/coo_2.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p_sec"
  }, [_vm._v("车务管理平台")]), _vm._v(" "), _c('p', {
    staticClass: "p_thir"
  }, [_vm._v("集车辆资料管理、驾驶员资料管理、用车调度、用车费用统计、车辆运维管理、统计报表于一体，实现合理使用公务车辆、驾驶员资源、智能调度车辆及驾驶员，并结合用车进度、短信通知、待办任务等亮点功能轻松实现车辆智能调度。")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "p_fri"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/index/coo_3.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p_sec"
  }, [_vm._v("风控管理平台")]), _vm._v(" "), _c('p', {
    staticClass: "p_thir"
  }, [_vm._v("集车辆、设备、车主、贷款、设备安装、风险预警、车主信用评估于一体，实现账户管理、信息管理、实时监控、资产分析、报表统计、风险预警、风险评估、信用评估等功能，结合用户自有数据及行业信息，为P2P车贷行业提供更多有效的数据基础。")])])]), _vm._v(" "), _c('p', {
    staticClass: "coo_href"
  }, [_c('a', {
    attrs: {
      "href": "http://clw.ishowchina.com:89/mygpsonline/",
      "target": "_blank"
    }
  }, [_vm._v("立即体验")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70303d0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/cooperativePartner.vue
// module id = 138
// module chunks = 1